import React from 'react';
import { EuiCard, EuiFlexGroup, EuiFlexItem, EuiSpacer, EuiText } from '@elastic/eui';
import NumberField from '../../../../components/Form/NumberField';
import SwitchField from '../../../../components/Form/SwitchField';
import CheckBoxField from '../../../../components/Form/CheckBoxField';

const PointsConfiguration = ({ control, errors, watch, setValue }) => {
    const isEnabled = watch('enable_points');

    return (
        <EuiCard title='Points System Configuration' description='Configure how customers earn and manage points'>
            <SwitchField
                name='enable_points'
                defaultValue={isEnabled || false}
                control={control}
                label='Enable Points System'
                setValue={setValue}
            />

            {isEnabled && (
                <>
                    <EuiSpacer size='l' />

                    {/* Earning Rules */}
                    <EuiText size='m'>
                        <h4>Earning Rules</h4>
                    </EuiText>
                    <EuiSpacer size='s' />

                    <EuiFlexGroup gutterSize='m' alignItems='flexEnd'>
                        <EuiFlexItem grow={false}>
                            <EuiText size='s'>Earn</EuiText>
                        </EuiFlexItem>
                        <EuiFlexItem grow={false}>
                            <NumberField
                                name='points_earning_rule_points'
                                control={control}
                                errors={errors}
                                placeholder='1'
                                rules={{
                                    required: 'Points required',
                                    min: { value: 1, message: 'Minimum 1 point' },
                                    max: { value: 100, message: 'Maximum 100 points' },
                                }}
                                compressed
                            />
                        </EuiFlexItem>
                        <EuiFlexItem grow={false}>
                            <EuiText size='s'>points for every ₹</EuiText>
                        </EuiFlexItem>
                        <EuiFlexItem grow={false}>
                            <NumberField
                                name='points_earning_rule_amount'
                                control={control}
                                errors={errors}
                                placeholder='100'
                                rules={{
                                    required: 'Amount required',
                                    min: { value: 1, message: 'Minimum ₹1' },
                                    max: { value: 1000, message: 'Maximum ₹1000' },
                                }}
                                compressed
                            />
                        </EuiFlexItem>
                        <EuiFlexItem grow={false}>
                            <EuiText size='s'>spent</EuiText>
                        </EuiFlexItem>
                    </EuiFlexGroup>

                    <EuiSpacer size='m' />

                    <CheckBoxField
                        name='calculate_points_after_discount'
                        control={control}
                        label='Calculate points on net amount (after discounts)'
                        setValue={setValue}
                    />

                    <CheckBoxField
                        name='universal_earning_rule'
                        control={control}
                        label='Universal earning rule for all order types'
                        setValue={setValue}
                    />

                    <EuiSpacer size='l' />

                    {/* Points Expiration */}
                    <NumberField
                        label='Points Expiration'
                        name='points_expiration_days'
                        control={control}
                        errors={errors}
                        placeholder='365'
                        prepend='After'
                        append='days'
                        rules={{
                            required: 'Expiration days required',
                            min: { value: 30, message: 'Minimum 30 days' },
                            max: { value: 730, message: 'Maximum 730 days' },
                        }}
                    />

                    <EuiSpacer size='l' />

                    {/* Signup Bonus */}
                    <NumberField
                        label='Signup Bonus'
                        name='points_signup_bonus'
                        control={control}
                        errors={errors}
                        placeholder='100'
                        append='points'
                        rules={{
                            required: 'Signup bonus required',
                            min: { value: 0, message: 'Cannot be negative' },
                            max: { value: 1000, message: 'Maximum 1000 points' },
                        }}
                        helpText='Points awarded to new customers upon registration'
                    />
                </>
            )}
        </EuiCard>
    );
};

export default React.memo(PointsConfiguration);
